<template>
  <div class="row">

    <div class="col-md-8">
      <Print
        :data="data"
        height="800px"
        :setting="setting"
      />
    </div>

    <!-- PDF -->
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      :filename="`test-laboratorium-${data.patient_name}`"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <Print
          :data="data"
          height="470px"
          :setting="setting"
        />
      </section>
    </vue-html2pdf>

    <div class="col-md">
      <div class="mb-3">
        <div class="text-muted small">No. hasil</div>
        <div class="font-weight-bold">{{ data.accession_number || '-' }}</div>
        <b-badge :variant="statusVariant(data.workflow_status)" class="mt-2">{{ data.workflow_status_label }}</b-badge>
      </div>
      <b-button
        squared
        class="d-block mt-2"
        size="sm"
        variant="success"
        v-if="canVerify && ['final', 'corrected'].includes(data.workflow_status)"
        @click="verifyReport"
      >Verifikasi Hasil</b-button>
      <b-button squared class="d-block mt-2" size="sm" variant="info" v-if="canOperate && !['cancelled'].includes(data.workflow_status)" @click="createSpecimen">Buat Spesimen & Barcode</b-button>
      <b-button squared class="d-block mt-2" size="sm" variant="danger" v-if="canOperate && data.has_critical_result && data.workflow_status !== 'verified'" @click="recordCritical">Catat Read-back Kritis</b-button>
      <b-button squared class="d-block mt-2" size="sm" variant="warning" v-if="canVerify && data.workflow_status === 'verified'" @click="createCorrection">Buat Koreksi</b-button>
      <b-button
        squared
        class="mt-2"
        size="sm"
        variant="primary"
        @click="btnPrintOnClick"
      >Print</b-button>
      <!-- <b-button
        squared
        :class="'d-block mt-2'"
        size="sm"
        variant="info"
        @click="btnDownloadOnClick"
      >Download</b-button> -->
      <b-button
        squared
        :class="'d-block mt-2'"
        size="sm"
        variant="success"
        v-if="manipulateBtn == true && ['draft', 'final', 'corrected'].includes(data.workflow_status)"
        @click="$router.push('/lab-report-2/edit/' + data.id)"
      >Edit Laporan</b-button>
      <b-button
        squared
        :class="'d-block mt-2'"
        size="sm"
        variant="success"
        v-if="manipulateBtn == true"
        @click="$router.push('/lab-report-2/add')"
      >Tambah Baru</b-button>
    </div>

  </div>
</template>

<script>

import Print from '@/component/lab-reports-2/Print.vue'
import module from '@/core/modules/CrudModule.js'
import ApiService from '@/core/services/api.service.js'
import VueHtml2pdf from "vue-html2pdf"
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Print,
    VueHtml2pdf
  },

  data() {
    return {
      // Data
      data: {},
      setting: {},
      manipulateBtn: false,
      canVerify: false,
      canOperate: false
    }
  },

  methods: {
    statusVariant(status) {
      return { draft: 'secondary', final: 'warning', verified: 'success', corrected: 'info', cancelled: 'danger' }[status] || 'secondary'
    },

    async verifyReport() {
      const confirmation = await Swal.fire({
        title: 'Verifikasi hasil laboratorium?',
        text: 'Setelah diverifikasi, hasil tidak dapat diedit atau dihapus langsung.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya, verifikasi',
        cancelButtonText: 'Batal'
      })
      if (!confirmation.isConfirmed) return
      const response = await module.submit({}, `lab-reports/${this.data.id}/verify`)
      if (response.state === 'success') {
        Swal.fire(response.success.title, response.success.message, 'success')
        this.get()
      }
    },

    async createSpecimen() {
      const answer = await Swal.fire({ title: 'Jenis spesimen', input: 'text', inputPlaceholder: 'Contoh: Darah EDTA', showCancelButton: true, inputValidator: value => !value ? 'Jenis spesimen wajib diisi' : undefined })
      if (!answer.isConfirmed) return
      const response = await ApiService.post('lab-specimens', { lab_id: this.data.id, specimen_type: answer.value })
      Swal.fire('Barcode dibuat', response.data.data.barcode, 'success')
    },

    async recordCritical() {
      const recipient = await Swal.fire({ title: 'Penerima informasi kritis', input: 'text', inputPlaceholder: 'Nama dokter/perawat', showCancelButton: true, inputValidator: value => !value ? 'Nama penerima wajib diisi' : undefined })
      if (!recipient.isConfirmed) return
      const criticalResults = (this.data.lab_results || []).filter(item => item.is_critical)
      for (const result of criticalResults) {
        const readback = await Swal.fire({ title: `Read-back: ${result.field_show_name}`, input: 'text', inputValue: result.result_text !== null ? result.result_text : result.result, showCancelButton: true, inputValidator: value => !value ? 'Nilai read-back wajib diisi' : undefined })
        if (!readback.isConfirmed) return
        await ApiService.post('lab-critical-notifications', { lab_id: this.data.id, lab_result_id: result.id, recipient_name: recipient.value, recipient_role: 'Dokter/tenaga klinis', channel: 'phone', read_back_confirmed: true, read_back_value: readback.value })
      }
      Swal.fire('Berhasil', 'Semua nilai kritis sudah dicatat dengan read-back.', 'success')
    },

    async createCorrection() {
      const answer = await Swal.fire({ title: 'Alasan koreksi', input: 'textarea', showCancelButton: true, inputValidator: value => !value || value.length < 5 ? 'Minimal 5 karakter' : undefined })
      if (!answer.isConfirmed) return
      const response = await ApiService.post(`lab-reports/${this.data.id}/correct`, { reason: answer.value })
      this.$router.push(`/lab-report-2/edit/${response.data.data.id}`)
    },

    async getSetting() {
      this.setting = await module.get(`settings/${1}`)
    },

    async get() {
      this.data = await module.get(`lab-reports/${this.$route.params.id}`)
      // If Data Not found
      if (this.data == null) {
        // Redirect To List
        this.$router.push('lab-report/list')
      }
    },

    onProgress($event) {
      console.log("onProgress", $event)
    },

    hasStartedGeneration() {
      console.log("hasStartedGeneration")
    },

    hasGenerated($event) {
      console.log("hasGenerated", $event)
    },

    btnPrintOnClick() {
      this.$htmlToPaper('print-lab-report')
    },

    btnDownloadOnClick() {
      this.$refs.html2Pdf.generatePdf()
    },

    // access management
    async setActiveMenu() {

      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for (a = 0; a < access_right.length; a++) {
        

        if (access_right[a] == "1104") {
          this.manipulateBtn = true
        }
        if (["1104", "1106"].includes(String(access_right[a]))) this.canVerify = true
        if (["1104", "1107"].includes(String(access_right[a]))) this.canOperate = true

      }
    },

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Pemeriksaan Lab" },
      { title: "Detail Laporan" },
    ])
    // Get Data
    this.get()
    this.getSetting()
    this.setActiveMenu()
  },

}
</script>

<style>
</style>
